import { Serializable } from '@admin/core/models/serializable';

export class FeatureModel implements Serializable<FeatureModel> {
  fromObject(object: any): FeatureModel {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public featureId: number;
  public keyName: string;
  public name: string;
  public featureType: number;
  public isChecked: boolean = false;
}
